import Vue from 'vue'
import router from '@/utils/router'
import VueAnalytics from 'vue-analytics'

Vue.use(VueAnalytics, {
  id: 'UA-134709991-1',
  router,
})